import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeBomWire } from '#/api/momMgmt/settings/bom/normalizeBomWire';
import { buildBomWritePayload } from '#/api/momMgmt/settings/bom/serializeBomWrite';

export async function updateBom(id, values) {
  const updatedAt = values?.updatedAt ?? values?.record?.updatedAt ?? null;
  const { data: raw } = await request.patch(
    `/mom/bom/${id}`,
    keysToSnake(buildBomWritePayload(values, { updatedAt })),
  );
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeBomWire(parsed.data),
  };
}
